import { useState } from 'react'
import { router } from '@inertiajs/react'
import DashboardLayout from '@/components/DashboardLayout'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Switch } from '@/components/ui/switch'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { ArrowLeft, UserPlus } from 'lucide-react'

interface Props {
  sources: { value: string; label: string }[]
  temperatures: { value: string; label: string }[]
}

export default function CrmNew({ sources, temperatures }: Props) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    source: 'whatsapp',
    temperature: 'warm',
    notes: ''
  })
  const [createUser, setCreateUser] = useState(true)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    router.post('/crm', { lead: form, create_user: createUser })
  }

  return (
    <DashboardLayout>
      <div className="p-4 sm:p-8 max-w-2xl mx-auto space-y-6">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => router.visit('/crm')}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
              <UserPlus className="h-5 w-5 text-primary" />
            </div>
            <h1 className="text-2xl font-bold">Novo Lead</h1>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Informações do Lead</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="name">Nome *</Label>
                <Input
                  id="name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Nome do lead"
                  required
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="phone">Telefone</Label>
                  <Input
                    id="phone"
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    placeholder="(00) 00000-0000"
                  />
                </div>
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    placeholder="email@exemplo.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <Label>Origem</Label>
                  <Select value={form.source} onValueChange={(v) => setForm({ ...form, source: v })}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {sources.map((s) => (
                        <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Temperatura</Label>
                  <Select value={form.temperature} onValueChange={(v) => setForm({ ...form, temperature: v })}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {temperatures.map((t) => (
                        <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              <div>
                <Label htmlFor="notes">Observações</Label>
                <Textarea
                  id="notes"
                  value={form.notes}
                  onChange={(e) => setForm({ ...form, notes: e.target.value })}
                  placeholder="Notas sobre este lead..."
                  rows={4}
                />
              </div>

              {/* Criar Usuário */}
              <div className="flex items-center justify-between p-4 border rounded-lg border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/30">
                <div className="space-y-0.5">
                  <Label htmlFor="create_user">Criar usuário no sistema</Label>
                  <p className="text-sm text-muted-foreground">
                    Cria o aluno automaticamente com uma senha temporária. Ele define a senha dele depois pelo app.
                    {createUser && !form.email && (
                      <span className="text-destructive font-medium block mt-1">Email é obrigatório para criar o usuário</span>
                    )}
                  </p>
                </div>
                <Switch
                  id="create_user"
                  checked={createUser}
                  onCheckedChange={setCreateUser}
                />
              </div>

              <div className="flex justify-end gap-2 pt-4">
                <Button type="button" variant="outline" onClick={() => router.visit('/crm')}>
                  Cancelar
                </Button>
                <Button type="submit" disabled={!form.name.trim()}>
                  <UserPlus className="h-4 w-4 mr-1" />
                  Criar Lead
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  )
}
